import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { portalApi, setPortalToken } from './portalApi';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '../components/ui/card';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

export const PortalLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await portalApi.post('/api/portal/auth/login', { email, password });
      setPortalToken(data.access_token);
      if (data.must_change_password) {
        navigate('/portal/trocar-senha');
      } else {
        navigate('/portal');
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Não foi possível entrar.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <Card className="w-full max-w-md" data-testid="portal-login-card">
        <CardHeader className="space-y-1 text-center">
          <CardTitle className="text-2xl">Portal do Cliente</CardTitle>
          <CardDescription>Acesse as informações do seu projeto</CardDescription>
        </CardHeader>
        <form onSubmit={handleSubmit}>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">E-mail</Label>
              <Input id="email" type="email" placeholder="seu@email.com" value={email}
                onChange={(e) => setEmail(e.target.value)} required data-testid="portal-email-input" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Senha</Label>
              <Input id="password" type="password" placeholder="••••••••" value={password}
                onChange={(e) => setPassword(e.target.value)} required data-testid="portal-password-input" />
            </div>
          </CardContent>
          <CardFooter className="flex flex-col gap-4">
            <Button type="submit" className="w-full" disabled={loading} data-testid="portal-login-button">
              {loading ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : null}
              {loading ? 'Entrando...' : 'Entrar'}
            </Button>
            <p className="text-xs text-center text-muted-foreground">por Proex Digital</p>
          </CardFooter>
        </form>
      </Card>
    </div>
  );
};
